






















































































































































































































import Vue from 'vue'
import router from '../router'

export default Vue.extend({
    name: 'Nav',

    data: () => ({


    }),
    methods: {
        gotoHome() {
            router.push('/').catch(err => {return err})
        }


    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    }
})
